import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ formComponents }: ComposedTheme) => ({
  block: {
    display: 'block',
    margin: [10, 0],
  },
  inline: {
    display: 'inline',
  },
  inlineBlock: {
    display: 'inline-block',
  },
  group: {
    paddingInlineStart: 0,
  },
  root: {
    border: 0,
    marginBottom: formComponents.container.marginBottom,
    padding: 0,
  },
  optionalText: {
    '& [class^="optional-"]': {
      marginLeft: 8,
    },
  },
});

export default createUseStyles(styles);
